import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    useEffect(() => {
        const scriptId = 'cloudmindx-chatbot-script';
        const styleId = 'cloudmindx-chatbot-embed-style';
        const widgetOrigin = 'https://chatbot-sigma-rosy.vercel.app';

        if (document.getElementById(scriptId)) return;

        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            @media (min-width: 505px) {
                #cloudmindx-chatbot-frame:not([data-chatbot-open="false"]) {
                    width: min(512px, calc(100vw - 24px)) !important;
                }
            }
        `;
        document.head.appendChild(style);

        const handleChatbotState = (event) => {
            const frame = document.getElementById('cloudmindx-chatbot-frame');

            if (
                event.origin !== widgetOrigin ||
                !frame ||
                event.source !== frame.contentWindow ||
                event.data?.type !== 'cloudmindx-chatbot-state'
            ) return;

            frame.dataset.chatbotOpen = String(Boolean(event.data.isOpen));
        };

        window.addEventListener('message', handleChatbotState);

        const script = document.createElement('script');
        script.id = scriptId;
        script.src = `${widgetOrigin}/cloudmindx-chatbot.js`;
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            window.removeEventListener('message', handleChatbotState);
            style.remove();
            script.remove();
        };
    }, []);

    return (
        <>
            <footer className="cm-footer">
                <div className="cm-footer-inner">

                    {/* Main Content Row: 4 columns */}
                    <div className="cm-footer-links-row">

                        {/* Column 1: Company Details */}
                        <div className="cm-footer-col cm-footer-company">
                            <div className="cm-footer-logo">
                                <h2>CLOUD MIND X</h2>
                            </div>
                            <p className="cm-footer-description">
                                Transforming businesses through innovative technology solutions. We deliver cutting-edge AI, cloud services, and digital transformation.
                            </p>
                            <div className="cm-footer-contact-info">
                                <div className="cm-footer-contact-item">
                                    <i className="fa fa-envelope"></i>
                                    <a href="mailto:info@cloudmindx.com">info@cloudmindx.com</a>
                                </div>
                                <div className="cm-footer-contact-item">
                                    <i className="fa fa-phone"></i>
                                    <a href="tel:+971501227432">+971-501227432</a>
                                </div>
                                <div className="cm-footer-contact-item">
                                    <i className="fa fa-map-marker"></i>
                                    <span style={{ textAlign: 'left' }}>One Business Center, Media One Hotel Tower - 38th Floor - Al Sufouh - Dubai Media City</span>
                                </div>
                            </div>
                            <div className="cm-footer-social">
                                <a href="#" className="cm-footer-social-btn" aria-label="Facebook">
                                    <i className="fa fa-facebook"></i>
                                </a>
                                <a href="#" className="cm-footer-social-btn" aria-label="Instagram">
                                    <i className="fa fa-instagram"></i>
                                </a>
                                <a href="#" className="cm-footer-social-btn" aria-label="LinkedIn">
                                    <i className="fa fa-linkedin"></i>
                                </a>
                                <a href="#" className="cm-footer-social-btn" aria-label="Twitter">
                                    <i className="fa fa-twitter"></i>
                                </a>
                            </div>
                        </div>

                        {/* Column 2: Services */}
                        <div className="cm-footer-col">
                            <h4 className="cm-footer-heading">Services</h4>
                            <ul>
                                <li><Link to="/services/ai-services">AI Services</Link></li>
                                <li><Link to="/services/app-development">App Development</Link></li>
                                <li><Link to="/services/website-development">Website Development</Link></li>
                                <li><Link to="/services/data-center">Data Center</Link></li>
                                <li><Link to="/services/cloud-services">Cloud Services</Link></li>
                                <li><Link to="/services/cyber-security">Cyber Security</Link></li>
                                <li><Link to="/services/digital-marketing">Digital Marketing</Link></li>
                                <li><Link to="/services/it-consulting">IT Consulting</Link></li>
                            </ul>
                        </div>

                        {/* Column 3: Solutions */}
                        <div className="cm-footer-col">
                            <h4 className="cm-footer-heading">Solutions</h4>
                            <ul>
                                <li><Link to="/ai-ml">AI & ML Solutions</Link></li>
                                <li><Link to="/salesforce">Salesforce</Link></li>
                                <li><Link to="/servicenow">ServiceNow</Link></li>
                                <li><Link to="/odoo">Odoo</Link></li>
                                <li><Link to="/sap">SAP</Link></li>
                                <li><Link to="/mvp-development">MVP Development</Link></li>
                                <li><Link to="/case-studies">Case Studies</Link></li>
                                <li><Link to="/industries">Industries</Link></li>
                            </ul>
                        </div>

                        {/* Column 4: Quick Links */}
                        <div className="cm-footer-col">
                            <h4 className="cm-footer-heading">Quick Links</h4>
                            <ul>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/contact">Contact Us</Link></li>
                                <li><Link to="/career">Careers</Link></li>
                                <li><Link to="/blog">Blogs</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/terms">Terms & Conditions</Link></li>
                                <li><a href="/sitemap.xml">Sitemap</a></li>
                            </ul>
                        </div>
                    </div>

                    <hr className="cm-footer-divider" />

                    {/* Bottom Row: copyright */}
                    <div className="cm-footer-bottom">
                        <p>Copyright © 2026 CLOUD MIND X. All rights reserved.</p>
                    </div>
                </div>
            </footer>

            <a
                className="whatsapp-float"
                href="https://wa.me/971501227432?text=Hello%20Cloud%20Mind%20X%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services."
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with Cloud Mind X on WhatsApp"
                title="Chat with us on WhatsApp"
            >
                <svg
                    viewBox="0 0 32 32"
                    aria-hidden="true"
                    focusable="false"
                >
                    <path
                        fill="currentColor"
                        d="M16.04 3A12.84 12.84 0 0 0 5 22.39L3.18 29l6.77-1.77A12.95 12.95 0 1 0 16.04 3Zm0 23.7a10.7 10.7 0 0 1-5.45-1.49l-.39-.23-4.02 1.05 1.07-3.91-.25-.4a10.72 10.72 0 1 1 9.04 4.98Zm5.88-8.03c-.32-.16-1.9-.94-2.2-1.05-.29-.11-.5-.16-.71.16-.22.32-.83 1.05-1.02 1.27-.19.21-.38.24-.7.08-.33-.16-1.37-.5-2.61-1.61a9.78 9.78 0 0 1-1.81-2.25c-.19-.32-.02-.5.14-.66.15-.14.33-.37.49-.56.16-.19.21-.32.32-.54.11-.21.06-.4-.02-.56-.08-.16-.72-1.73-.99-2.37-.26-.63-.52-.54-.71-.55h-.61c-.22 0-.57.08-.86.4-.3.32-1.13 1.1-1.13 2.68 0 1.59 1.16 3.12 1.32 3.34.16.21 2.28 3.48 5.52 4.88.77.33 1.37.53 1.84.68.77.25 1.47.21 2.03.13.62-.09 1.9-.78 2.17-1.53.27-.75.27-1.4.19-1.53-.08-.14-.3-.22-.62-.38Z"
                    />
                </svg>
            </a>
        </>
    )
}
